export default function () {
  const body = document.querySelector("body");
	const footer = document.querySelector("#site-footer");

  if(!footer) {
    return;
  }

  function updateStyle() {
    body.style.paddingBottom =`${footer.offsetHeight - 1}px`;
  }

  function footerFocusHandling() {
    const focusableElements = footer.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

    focusableElements.forEach(el => {
      el.addEventListener('focus', () => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      });
    });
  }

  updateStyle();
  footerFocusHandling();

	window.addEventListener("resize", function () {
		updateStyle();
	});
}
